var _rect, _g, _rect2, _g2, _g3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBannerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 448,
    viewBox: "0 0 496 548",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_241_340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 140,
    width: 380,
    height: 381
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 200.109,
    width: 325.532,
    height: 325.532,
    transform: "rotate(-10.4681 49 200.109)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_241_340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.707 317.01L259.345 293.402C266.082 288.806 273.136 284.99 280.506 281.953C287.876 278.916 295.785 276.617 304.232 275.056C310.012 273.988 315.766 273.404 321.495 273.302C327.223 273.201 332.884 273.352 338.475 273.755L342.581 295.974C336.861 294.877 331.181 294.311 325.542 294.275C319.903 294.24 314.083 294.777 308.081 295.886C299.633 297.447 291.723 300.045 284.348 303.682C276.974 307.318 270.094 311.761 263.707 317.01ZM277.819 393.387L273.457 369.779C280.194 365.184 287.248 361.367 294.618 358.33C301.988 355.293 309.896 352.994 318.344 351.433C324.124 350.365 329.878 349.781 335.607 349.68C341.335 349.579 346.995 349.73 352.587 350.133L356.692 372.352C350.972 371.254 345.293 370.688 339.654 370.653C334.015 370.618 328.195 371.154 322.193 372.263C313.745 373.824 305.824 376.365 298.428 379.885C291.032 383.406 284.162 387.906 277.819 393.387ZM270.763 355.198L266.401 331.591C273.138 326.995 280.192 323.179 287.562 320.141C294.932 317.104 302.841 314.805 311.288 313.245C317.068 312.177 322.822 311.592 328.551 311.491C334.279 311.39 339.939 311.541 345.531 311.944L349.636 334.163C343.916 333.066 338.237 332.499 332.598 332.464C326.959 332.429 321.139 332.966 315.137 334.075C306.689 335.636 298.778 338.234 291.404 341.87C284.03 345.507 277.149 349.949 270.763 355.198ZM268.714 418.764C277.597 412.097 286.761 406.634 296.204 402.376C305.647 398.118 315.593 395.024 326.041 393.094C334.044 391.615 342.008 390.861 349.934 390.833C357.86 390.805 365.97 391.461 374.264 392.8L348.863 255.321C340.928 253.436 332.865 252.413 324.674 252.251C316.483 252.089 308.386 252.747 300.384 254.226C289.935 256.156 279.855 259.455 270.142 264.121C260.43 268.788 251.529 274.741 243.441 281.98L268.714 418.764ZM262.945 462.195C250.649 455.371 237.828 450.679 224.481 448.119C211.135 445.559 197.792 445.511 184.454 447.975C175.117 449.7 166.183 452.668 157.65 456.877C149.117 461.086 141.166 466.265 133.796 472.414C129.598 475.822 125.075 476.538 120.227 474.562C115.379 472.586 112.463 468.936 111.479 463.612L80.562 296.277C80.0917 293.731 80.254 291.188 81.049 288.647C81.844 286.107 83.3573 284.032 85.5888 282.423C95.0534 275.169 105.02 269.079 115.49 264.153C125.959 259.227 136.974 255.696 148.533 253.56C161.427 251.178 174.363 250.583 187.342 251.775C200.321 252.967 213.121 255.988 225.741 260.836C235.796 251.798 246.671 244.404 258.367 238.652C270.064 232.901 282.359 228.834 295.252 226.452C306.812 224.316 318.361 223.678 329.899 224.538C341.438 225.398 352.923 227.525 364.354 230.918C367.014 231.623 369.168 233.02 370.819 235.109C372.469 237.197 373.529 239.514 374 242.06L404.917 409.396C405.901 414.719 404.481 419.17 400.66 422.748C396.838 426.327 392.358 427.274 387.219 425.591C378.139 422.482 368.862 420.486 359.388 419.603C349.915 418.721 340.509 419.142 331.173 420.867C317.835 423.332 305.39 428.144 293.839 435.304C282.289 442.465 271.99 451.428 262.945 462.195Z",
    fill: "url(#paint0_linear_241_340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.775 418.938L268.055 420.453L269.287 419.528C278.118 412.9 287.221 407.474 296.596 403.247C305.968 399.021 315.84 395.95 326.215 394.033C334.163 392.564 342.07 391.816 349.938 391.788C357.809 391.76 365.866 392.411 374.112 393.743L375.449 393.959L375.203 392.627L349.802 255.148L349.689 254.536L349.084 254.392C341.083 252.491 332.952 251.459 324.693 251.296C316.438 251.133 308.277 251.796 300.21 253.287C289.678 255.233 279.517 258.558 269.729 263.261C259.934 267.967 250.959 273.97 242.804 281.268L242.405 281.626L242.502 282.153L267.775 418.938ZM86.1473 283.198L86.1586 283.19L86.1697 283.181C95.5818 275.968 105.491 269.914 115.896 265.017C126.29 260.127 137.226 256.621 148.707 254.499C161.515 252.133 174.363 251.542 187.255 252.726C200.143 253.91 212.857 256.909 225.399 261.728L225.945 261.938L226.38 261.547C236.371 252.565 247.174 245.22 258.789 239.509C270.406 233.797 282.618 229.758 295.426 227.391C306.906 225.27 318.373 224.637 329.828 225.491C341.297 226.345 352.714 228.459 364.083 231.833L364.096 231.837L364.11 231.841C366.576 232.495 368.551 233.78 370.069 235.701C371.626 237.671 372.619 239.845 373.06 242.234L403.978 409.57C404.905 414.586 403.582 418.704 400.007 422.051C398.205 423.739 396.282 424.776 394.236 425.208C392.189 425.641 389.958 425.482 387.521 424.685C378.372 421.553 369.023 419.542 359.477 418.652C349.916 417.762 340.422 418.187 330.999 419.928C317.544 422.414 304.988 427.27 293.336 434.493C281.912 441.575 271.706 450.406 262.721 460.981C250.549 454.315 237.862 449.714 224.661 447.181C211.198 444.599 197.736 444.55 184.28 447.036C174.857 448.777 165.839 451.772 157.227 456.021C148.628 460.263 140.615 465.481 133.19 471.676C131.199 473.291 129.172 474.237 127.106 474.564C125.04 474.891 122.874 474.61 120.587 473.678C116.053 471.829 113.345 468.455 112.419 463.439L81.5011 296.103C81.0598 293.715 81.2104 291.329 81.9604 288.932C82.6916 286.596 84.0772 284.69 86.1473 283.198ZM337.671 274.656L341.389 294.783C336.077 293.841 330.796 293.353 325.548 293.32C319.845 293.285 313.964 293.828 307.907 294.947C299.377 296.523 291.382 299.148 283.926 302.825C276.966 306.257 270.442 310.401 264.354 315.257L260.397 293.842C266.926 289.438 273.75 285.77 280.87 282.836C288.174 279.826 296.019 277.545 304.406 275.995C310.135 274.936 315.837 274.357 321.512 274.257C326.961 274.161 332.347 274.294 337.671 274.656ZM351.782 351.034L355.501 371.161C350.188 370.218 344.908 369.731 339.66 369.698C333.956 369.662 328.076 370.205 322.019 371.324C313.494 372.9 305.492 375.465 298.017 379.023C291.031 382.349 284.511 386.539 278.458 391.591L274.509 370.219C281.037 365.816 287.861 362.147 294.982 359.213C302.286 356.203 310.13 353.922 318.517 352.372C324.247 351.314 329.949 350.735 335.623 350.635C341.073 350.539 346.459 350.672 351.782 351.034ZM344.727 312.845L348.445 332.972C343.133 332.03 337.852 331.542 332.604 331.509C326.9 331.474 321.02 332.017 314.963 333.136C306.433 334.712 298.438 337.337 290.982 341.014C284.022 344.446 277.497 348.59 271.41 353.445L267.453 332.031C273.981 327.627 280.805 323.959 287.926 321.024C295.23 318.014 303.074 315.733 311.462 314.184C317.191 313.125 322.893 312.546 328.568 312.446C334.017 312.35 339.403 312.483 344.727 312.845Z",
    stroke: "url(#paint1_linear_241_340)",
    strokeOpacity: 0.2,
    strokeWidth: 1.90996
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344.128,
    y: 54.9403,
    width: 96.956,
    height: 113.115,
    rx: 30.5606,
    transform: "rotate(32.2594 344.128 54.9403)",
    fill: "url(#paint2_linear_241_340)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_241_340)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_241_340",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.629 109.6C314.393 102.053 324.372 99.7967 331.919 104.56L386.579 139.061C394.126 143.824 396.383 153.804 391.619 161.351L318.771 276.765C315.645 281.719 311.231 285.729 306.001 288.368L280.346 301.315L231.153 270.264L231.801 241.534C231.933 235.678 233.655 229.968 236.781 225.015L309.629 109.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.629 109.6C314.393 102.053 324.372 99.7967 331.919 104.56L386.579 139.061C394.126 143.824 396.383 153.804 391.619 161.351L318.771 276.765C315.645 281.719 311.231 285.729 306.001 288.368L280.346 301.315L231.153 270.264L231.801 241.534C231.933 235.678 233.655 229.968 236.781 225.015L309.629 109.6Z",
    fill: "#D7C0FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.919 104.56L330.827 106.291L330.827 106.291L331.919 104.56ZM309.629 109.6L307.898 108.508L309.629 109.6ZM386.579 139.061L385.487 140.791L386.579 139.061ZM391.619 161.351L393.35 162.443L391.619 161.351ZM318.771 276.765L317.04 275.673L318.771 276.765ZM306.001 288.368L306.923 290.196L306.001 288.368ZM280.346 301.315L279.254 303.045L280.234 303.664L281.268 303.142L280.346 301.315ZM231.153 270.264L229.107 270.218L229.08 271.377L230.06 271.995L231.153 270.264ZM231.801 241.534L229.755 241.488L229.755 241.488L231.801 241.534ZM236.781 225.015L235.05 223.922L235.05 223.922L236.781 225.015ZM333.012 102.829C324.509 97.4625 313.265 100.005 307.898 108.508L311.36 110.693C315.52 104.102 324.236 102.131 330.827 106.291L333.012 102.829ZM387.672 137.33L333.012 102.829L330.827 106.291L385.487 140.791L387.672 137.33ZM393.35 162.443C398.717 153.94 396.174 142.697 387.672 137.33L385.487 140.791C392.078 144.952 394.048 153.667 389.888 160.258L393.35 162.443ZM320.502 277.858L393.35 162.443L389.888 160.258L317.04 275.673L320.502 277.858ZM306.923 290.196C312.484 287.39 317.177 283.125 320.502 277.858L317.04 275.673C314.112 280.313 309.977 284.069 305.079 286.541L306.923 290.196ZM281.268 303.142L306.923 290.196L305.079 286.541L279.424 299.487L281.268 303.142ZM281.439 299.584L232.245 268.534L230.06 271.995L279.254 303.045L281.439 299.584ZM235.05 223.922C231.726 229.189 229.895 235.261 229.755 241.488L233.847 241.581C233.971 236.095 235.584 230.747 238.512 226.107L235.05 223.922ZM307.898 108.508L235.05 223.922L238.512 226.107L311.36 110.693L307.898 108.508ZM233.199 270.311L233.847 241.58L229.755 241.488L229.107 270.218L233.199 270.311Z",
    fill: "url(#paint3_linear_241_340)",
    mask: "url(#path-5-inside-1_241_340)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_241_340)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.6373,
    height: 16.1593,
    rx: 8.07967,
    transform: "matrix(-0.84564 -0.533754 -0.533754 0.84564 377.953 152.725)",
    fill: "url(#paint4_linear_241_340)",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.789875,
    y: 0.178594,
    width: 63.4921,
    height: 15.0141,
    rx: 7.50704,
    transform: "matrix(-0.84564 -0.533754 -0.533754 0.84564 376.591 152.331)",
    stroke: "url(#paint5_linear_241_340)",
    strokeWidth: 1.14525
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.347 301.315L231.153 270.264L230.179 313.322C230.041 319.42 236.451 323.466 241.897 320.718L280.347 301.315Z",
    fill: "url(#paint6_linear_241_340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_241_340",
    x: 212.053,
    y: 82.9642,
    width: 201.162,
    height: 237.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.54978
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_241_340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_241_340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_241_340",
    x: 256.611,
    y: 60.1681,
    width: 179.399,
    height: 164.279,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 30.5606
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_241_340"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_241_340",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_340",
    x1: 224.275,
    y1: 252.899,
    x2: 265.221,
    y2: 474.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8769FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC67FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_340",
    x1: 220.322,
    y1: 231.504,
    x2: 262.945,
    y2: 462.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_241_340",
    x1: 372.096,
    y1: 79.6843,
    x2: 448.637,
    y2: 102.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6400E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_241_340",
    x1: 187.831,
    y1: 130.147,
    x2: 349.33,
    y2: 280.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1643,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_241_340",
    x1: 65.8716,
    y1: 9.01035,
    x2: -27.4247,
    y2: 6.63424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFDFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_241_340",
    x1: 63.9289,
    y1: 11.1136,
    x2: 32.3187,
    y2: 16.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_241_340",
    x1: 240.573,
    y1: 286.778,
    x2: 264.096,
    y2: 324.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#917FFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6400E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerIcon);
export default __webpack_public_path__ + "static/media/banner-icon.710937c9c1ff1ef7fba6bdf95fc2d557.svg";
export { ForwardRef as ReactComponent };